import { Group } from "@mantine/core"
import { AgencyOperationsAdminVenueBookingTabs } from "src/components/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBookingTabs"
import { EditAgencyOperationsAdminVenueBookingAction } from "src/components/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBookingActions"
import { useAppState } from "src/state"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { formatDate, formatTime } from "src/utils/dates"
import { AgencyOperationsAdminVenueBookingView } from "src/components/agency/operations/administrator/venues/bookings/AgencyOperationsAdminVenueBookingView"

export function AgencyOperationsAdminVenueBookingOverlay() {

    const { currentItem } = useAppState(state=>state.bookings)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.talent?.alias} ${formatDate(currentItem?.date)} ${!!currentItem?.set_start_time ? '@ ': ''}${formatTime(currentItem?.set_start_time)}`}
                    renderAction={
                        <Group gap="sm">
                            <EditAgencyOperationsAdminVenueBookingAction />
                        </Group>
                    }
                />
            }
        >
            <AgencyOperationsAdminVenueBookingTabs overlay/>
            <AgencyOperationsAdminVenueBookingView/>
        </DrawerPageLayout>
    )

}